/**
 * PlantillasApiClient – /api/v1/businesses/{businessId}/plantillas
 * Gestiona plantillas de horario semanal (template-based scheduling).
 */

import { ApiBase } from './ApiBase.js';

function base(businessId) {
  return `/api/v1/businesses/${businessId}/plantillas`;
}

export const PlantillasApiClient = {
  /** Lista todas las plantillas activas. Filtra por colaboradorId si se pasa. */
  async list(businessId, colaboradorId = null) {
    let url = base(businessId);
    if (colaboradorId) url += `?colaboradorId=${encodeURIComponent(colaboradorId)}`;
    return ApiBase.get(url);
  },

  /**
   * Devuelve quién trabaja en una fecha determinada (resuelve día de semana).
   * Útil para la vista de Cobertura.
   */
  async cobertura(businessId, fecha) {
    const f = fecha || new Date().toISOString().slice(0, 10);
    return ApiBase.get(`${base(businessId)}/cobertura?fecha=${encodeURIComponent(f)}`);
  },

  async getById(businessId, id) {
    return ApiBase.get(`${base(businessId)}/${id}`);
  },

  /**
   * Crea o actualiza la plantilla para un colaborador + día de semana.
   * Si ya existe para ese par, la reemplaza (UPSERT).
   */
  async upsert(businessId, payload) {
    return ApiBase.post(base(businessId), payload);
  },

  async update(businessId, id, payload) {
    return ApiBase.put(`${base(businessId)}/${id}`, payload);
  },

  async delete(businessId, id) {
    return ApiBase.del(`${base(businessId)}/${id}`);
  },
};
